import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/projects/michelin-hp/node_modules/@babel/runtime/helpers/asyncToGenerator";
import Cookies from 'quasar/src/plugins/Cookies.js';;
import { axiosInstance } from './axios';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var store;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = _ref.store;

            if (Cookies.has('auth_token')) {
              store.commit('auth/isAuthenticated', true);
              axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + Cookies.get('auth_token');
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();